import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 0,
      key: 'Local',
      name: i18n.t('tipos.auth.local')
    },
    {
      id: 1,
      key: 'AAD',
      name: i18n.t('tipos.auth.aad')
    },
    {
      id: 2,
      key: 'Mixto',
      name: i18n.t('tipos.auth.mixto')
    },
    {
      id: 3,
      key: 'SAML2',
      name: i18n.t('tipos.auth.saml2'),
    },
    {
      id: 4,
      key: 'MixtoSAML2',
      name: i18n.t('tipos.auth.mixto_saml2'),
    }
  ]
}

export function TIPOS_AUTH (state) {
  return configHelper.getConfig(state, 'TIPOS_AUTH', GenerateConfig)
}
